import { Outlet, ScrollRestoration, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { useContext } from "react";

import Menu from "./Menu";
import Footer from "./Footer";

import useScrollTop from "../../hooks/useScrollTop";
import { mainContext } from "../../context/mainContext";

import { useTranslation } from "../../hooks/useTranslation";
import { getSeoByPath } from "../../services/seoRouteHelper";
import Seo from "../shared/Seo";

export default function MainLayout() {
  const { language } = useContext(mainContext);
  const t = useTranslation();
  const location = useLocation();

  const { title, description } = getSeoByPath(t, location.pathname);

  useScrollTop();

  return (
    <>
      <Helmet>
        <html lang={language} />
      </Helmet>

      <ScrollRestoration />

      <Seo title={title} description={description} />

      <div id="layoutDiv">
        <Menu />
        <main id="main">
          <Outlet />
        </main>
        <Footer />
      </div>
    </>
  );
}
